import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import CashFlowData from '../../components/Cashflow/InvoiceList';
import { VocuherCategory } from "../../utils/common-utils";

const AccountReceivable =() => {
    return(
      <>
        {/* <Breadcrumb /> */}
        <CashFlowData accountType={"Invoices"} type={VocuherCategory.SALE} />
      </>
    );
};
export default AccountReceivable;